import { Box, Button, styled, Typography } from '@mui/material';
import { DateTime } from 'luxon';

import PropTypes from 'prop-types';
import * as dataService from './dataService';
import { BaseWidget, PermissionWall, ResendEmailModal } from 'modules/layer01';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip } from '@mui/material';
import { modalUtil } from 'iron-forge-react-modules';
import { SendGridEmailStatusName } from 'generated/graphql';



const ButtonBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  marginRight: theme.spacing(2)
}));

export interface IProps {
  storeId: string;
  orderId?: string;
  returnAuthorizationId?: string;
}

const __sendGridEmailStatus2ChipColor: Record<SendGridEmailStatusName, "success" | "warning" | "error"> = {
  delivered: "success",
  processed: "warning",
  deferred: "warning",
  failed: "error",
  dropped: "error",
  bounce: "error"
};

export const FC: React.FC<IProps> = props => {

  const {
    modalType2IsOpen,
    setModalIsOpen
  } = modalUtil.useModalTrackers([
    'resendEmail'
  ]);

  const tuple = dataService.useQuery({
    orderId: props.orderId,
    returnAuthorizationId: props?.returnAuthorizationId
  });

  function handleCloseResendEmailModal() {
    setModalIsOpen('resendEmail', false);
  }

  function handleClickResendEmail() {
    setModalIsOpen('resendEmail', true);
  }

  return (
    <>
      <BaseWidget.FC
        title={`${props.orderId ? 'Order' : 'Return Authorization'} Email History`}
        elAction={(
          <ButtonBox>
            <PermissionWall.FC
              storeId={props.storeId}
              requiresPermissions={['customer_email']}>
              <Button
                variant="contained"
                onClick={handleClickResendEmail}>
                Email Customer
              </Button>
            </PermissionWall.FC>
          </ButtonBox>
        )}>

        <TableContainer component={Paper} sx={{ mt: 2 }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Status</TableCell>
                <TableCell>Sent At</TableCell>
                <TableCell>Recipient Emails</TableCell>
                <TableCell>Event Name</TableCell>
                <TableCell>Error</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tuple?.data?.sendGridEmailRequests?.length ? (
                tuple.data.sendGridEmailRequests.map(email => (
                  <TableRow key={email.id}>
                    <TableCell>
                      <Chip
                        label={email.status.displayName}
                        color={__sendGridEmailStatus2ChipColor[email.status.name]}
                        size="small"
                      />
                    </TableCell>
                    <TableCell>
                      {email.createdAt instanceof DateTime
                        ? email.createdAt.toFormat('yyyy-MM-dd @ hh:mm a')
                        : '-'}
                    </TableCell>
                    <TableCell>
                      {email.recipientEmails.join(', ')}
                    </TableCell>
                    <TableCell>
                      {email.appEvent ?? '-'}
                    </TableCell>
                    <TableCell>
                      {email.errorReason ?? '-'}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4}>
                    <Typography align="center" variant="body2" color="textSecondary">
                      No email history found.
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </BaseWidget.FC >

      {modalType2IsOpen.resendEmail && (
        <ResendEmailModal.FC
          orderId={props.orderId}
          returnAuthorizationId={props.returnAuthorizationId}
          onClose={handleCloseResendEmailModal} />
      )}
    </>
  );
};

FC.propTypes = {
  storeId: PropTypes.string.isRequired,
  orderId: PropTypes.string,
  returnAuthorizationId: PropTypes.string
};


